<template>
  <section>
    <md-progress-bar
      md-mode="query"
      v-if="menuData == null || menuData.length == 0"
    ></md-progress-bar>
    <md-empty-state
      v-if="!treatments.length"
      class="md-secondary md-small"
      md-icon="hourglass_top"
      md-label="No treatments found."
      md-description="As an admin you can add treatments to this booking system."
    >
    </md-empty-state>
    <md-list>
      <md-list-item
        v-for="(item, index) in treatments"
        :key="item.name"
        @click="selectTreatment(index)"
      >
        <router-link :to="$route.path + '/' + index">
          <span class="md-list-item-text"
            >{{ item.name }} - {{ item.price }}</span
          >
        </router-link>
      </md-list-item>
    </md-list>
  </section>
</template>

<script>
import { eventBus } from "../../eventbus";

export default {
  name: "ChooseTreatment",
  props: {
    categoryId: String,
  },
  data: function () {
    return {
      selectedTreatment: null,
      selectedTreatmentIndex: null,
      timeReserved: false,
      noMenuDataLoaded: false,
    };
  },
  computed: {
    treatments() {
      var data = null;

      // if (this.menuData != null) {
      //   data = this.menuData.find((el) => el.cat == this.treatmentCategory);
      //   if (
      //     data == null &&
      //     this.treatmentCategoryIndex < this.menuData.length
      //   ) {
      //     data = this.menuData[this.treatmentCategoryIndex];
      //   }
      // }
      data = this.menuData[parseInt(this.categoryId)];
      return data != null ? data.items : [];
    },
    menuData() {
      return this.$store.state.menuData;
    },
  },
  watch: {
    categoryId: function (newVal, oldVal) {
      console.log("NewCat Id {0} and old catId was {1}", newVal, oldVal);
    },
  },
  methods: {
    selectTreatment: function (index) {
      console.log("selectTreatment", index);
      this.$store.commit("user/selectTreatment", this.treatments[index]);
      this.selectedTreatmentIndex = index;

      this.timeReserved = false;

      eventBus.selectedTreatment(this.treatments[index]);

      eventBus.updateDialogTitle(
        this.treatments[index].name,
        this.treatments[index].price
      );
    },
    resetBooking: function () {
      // TODO combine below
      this.timeReserved = false;
      this.selectedTime = null;
    },
  },
  created: function () {},
};
</script>

<style>
</style>